import styled from 'styled-components';

export const CloseIconPanel = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  border-left: 1px solid #815ca7;
`;

export const PrivateIncentiveClosePanel = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
`;
